// packages/hooks/src/useDashboard.ts
import { useState, useEffect } from 'react';
import { useToken } from '../auth/useToken';
import {  dashboardService } from '../../services/dashboardService';
import { AdminDashboardData } from '../../types/Dashboard';

export function useAdminDashboard() {
  const { token } = useToken();
  const [data, setData] = useState<AdminDashboardData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDashboard = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const result = await dashboardService.getAdminStats(token);
        setData(result);
      } catch (err: any) {
        setError(err.message || 'Erreur lors du chargement du tableau de bord');
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
  }, [token]);

  return { data, loading, error };
}

